import { render, staticRenderFns } from "./answerPop.vue?vue&type=template&id=03802a66&scoped=true&"
import script from "./answerPop.vue?vue&type=script&lang=js&"
export * from "./answerPop.vue?vue&type=script&lang=js&"
import style0 from "./answerPop.vue?vue&type=style&index=0&id=03802a66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03802a66",
  null
  
)

export default component.exports